/*
 * Newsletter signup (sections/totl-newsletter-signup.liquid).
 *
 * Subscribes the email to a Klaviyo list with Klaviyo's public client API,
 * the same way Klaviyo's own forms do, with the (required) first name as the
 * profile's first name and the 21+ checkbox as the profile property
 * "Email Age Consent" (both as the popup does).
 */
(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function subscribe(form, email, firstName) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.companyId);
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.dataset.source || undefined,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName || undefined,
                properties: { 'Email Age Consent': ['21+'] }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: form.dataset.listId } }
        }
      }
    };
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (response) {
      // Klaviyo answers 202 Accepted with an empty body.
      if (!response.ok) throw new Error('Klaviyo ' + response.status);
    });
  }

  function init(form) {
    if (form.dataset.tbNewsletterBound) return;
    form.dataset.tbNewsletterBound = 'true';

    var body = form.parentNode;
    var texts = body.querySelector('.tb-newsletter__success');
    var message = form.querySelector('.tb-newsletter__message');
    var button = form.querySelector('.tb-newsletter__button');

    function show(text) {
      message.textContent = text;
      message.hidden = false;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = form.elements.email.value.trim();
      var firstName = form.elements.first_name ? form.elements.first_name.value.trim() : '';
      if (form.elements.first_name && !firstName) return show(texts.dataset.errorFirstName);
      if (!EMAIL_RE.test(email)) return show(texts.dataset.errorEmail);
      if (!form.elements.age_consent.checked) return show(texts.dataset.errorConsent);

      message.hidden = true;
      button.disabled = true;
      subscribe(form, email, firstName)
        .then(function () {
          // Also identify the visitor to Klaviyo's onsite script (if loaded),
          // so this browser's activity is tied to the new profile.
          if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
            var traits = { email: email, 'Email Age Consent': ['21+'] };
            if (firstName) traits.first_name = firstName;
            window.klaviyo.identify(traits);
          }
          form.hidden = true;
          texts.textContent = texts.dataset.success;
          texts.hidden = false;
        })
        .catch(function () {
          button.disabled = false;
          show(texts.dataset.errorGeneral);
        });
    });
  }

  function initAll() {
    document.querySelectorAll('form[data-tb-newsletter]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor: re-bind when the section is added or reloaded.
  document.addEventListener('shopify:section:load', initAll);
})();
